<template>
    <div>
        <formulaire-calculette></formulaire-calculette>
    </div>
</template>

<script>

import FormulaireCalculette from '@/components/calculette/Etape1.vue';

export default {
  name: 'calculette',
  components: { FormulaireCalculette },
};
</script>

<style scoped>

</style>
